import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MessageBroadcastingService } from '../message-broadcasting.service';
import { AuthService } from '../../core/security/auth.service';
import { FileHelpers } from '../../core/utilities/file.helpers';
import { MediaPreviewModel } from '../../messaging/message/media-preview.model';
import { MatDialog } from '@angular/material/dialog';
import { MessageBroadcastThreadModel } from '../../api/models/message-broadcast-thread-model';
import { FlexModule } from '@angular/flex-layout';
import { NgFor, NgIf, PercentPipe } from '@angular/common';
import { HighlightPipe } from '../../core/pipes/highlight.pipe';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';

@Component({
    selector: 'app-broadcast-one-message',
    template: `
    <div class="message-item message-item-right" [fxLayout]="'row-reverse'">
      <div class="message-item-body" fxLayout="column inline">
        <!-- Heading -->
        <div class="message-item-heading">
          <div class="message-item-info">
            <span class="time" [title]="model.lastTime | dateTime">{{ model.lastTime | dateTime: 'today' }}</span>
            <span>{{ model.createdBy }}</span>
          </div>
        </div>

        <!-- Content -->
        <div class="message-item-content" fxFlex="auto">
          <div *ngFor="let media of imagesList">
            <a [href]="media.url" target="_blank">
              <img class="image-preview" [src]="media.url" [alt]="media.displayName" />
            </a>
          </div>
          <div *ngFor="let media of videoList">
            <a [href]="media.url" target="_blank">
              <video controls class="image-preview" [src]="media.url"></video>
            </a>
          </div>
          <div *ngFor="let media of audioList">
            <a [href]="media.url" target="_blank">
              <audio controls class="image-preview" [src]="media.url"></audio>
            </a>
          </div>
          <div *ngFor="let media of otherList">
            <a [href]="media.url" target="_blank" style="display: block">
              {{ media.displayName }}
            </a>
          </div>
          <div style="overflow: hidden;">
            <span
              style="white-space: pre-line; font-style: italic; text-align: left; display: inline-block; max-width: 100%;"
              [innerHTML]="messageText | highlight: searchText"
            ></span>
          </div>
        </div>
        <div class="message-item-footer">
          <span class="status">
            <span *ngIf="isSending">Sending to:</span>
            <span
              ><b>{{ model.total || 0 }} Contacts</b></span
            >
            <span>{{ model.received / model.total || 0.001 | percent }} delivered</span>
            <a (click)="showMessageLogs.emit({ type: 'outgoing', threadKey: model.broadcastKey })"
              >{{ model.received || 0 }} delivered</a
            >
            <a (click)="showMessageLogs.emit({ type: 'failed', threadKey: model.broadcastKey })"
              >{{ model.error || 0 }} unsuccessful</a
            >
          </span>
        </div>
      </div>
    </div>
  `,
    styleUrls: ['./broadcast-one-message.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        NgFor,
        NgIf,
        PercentPipe,
        HighlightPipe,
        DateTimePipe,
    ],
})
export class BroadcastOneMessageComponent implements OnChanges {
  @Input() model: MessageBroadcastThreadModel;
  @Input() searchText: string;
  @Output() showMessageLogs = new EventEmitter<{ type: string; threadKey: string }>();

  isSending = false;
  messageText: string;
  imagesList: MediaPreviewModel[] = [];
  audioList: MediaPreviewModel[] = [];
  videoList: MediaPreviewModel[] = [];
  otherList: MediaPreviewModel[] = [];

  constructor(
    public messagingService: MessageBroadcastingService,
    public authService: AuthService,
    public dialog: MatDialog,
  ) {}

  ngOnChanges() {
    this.isSending = this.model.total > (this.model.received || 0) + (this.model.error || 0);

    this.messageText = this.model.message;

    this.imagesList = [];
    this.audioList = [];
    this.videoList = [];
    this.otherList = [];

    if (this.model.media) {
      let index = 1;
      for (const media of this.model.media) {
        const mediaFile = new MediaPreviewModel();
        mediaFile.filename = media.filename;
        mediaFile.displayName = `attachment-${index++}.${FileHelpers.getExtension(media.filename)}`;

        if (media.mediaType.indexOf('image') > -1) {
          mediaFile.url = `/api/advanced-messaging/stream-media/${media.filename}`;
          this.imagesList.push(mediaFile);
        } else if (media.mediaType.indexOf('audio') > -1) {
          mediaFile.url = `/api/advanced-messaging/stream-media/${media.filename}`;
          this.audioList.push(mediaFile);
        } else if (media.mediaType.indexOf('video') > -1) {
          mediaFile.url = `/api/advanced-messaging/stream-media/${media.filename}`;
          this.videoList.push(mediaFile);
        } else {
          mediaFile.url = `/api/advanced-messaging/download-media/${media.filename}`;
          this.otherList.push(mediaFile);
        }
      }
    }
  }
}
